/*
  The starburst that blooms behind a solved board.

  One path, filled with a radial gradient in the game's colours, and a viewBox that is square so it
  can be centred on the board at whatever size the board happens to be. The artwork is here rather
  than in either client because both draw it — the website as an inline <svg>, the app through
  react-native-svg — and a burst that drifted between them would be two different celebrations.

  The gradient's stops carry the shape of the fade: solid at the middle, the game's colour to 40%,
  then out to nothing by the edge, which is what keeps it from ending in a hard circle.
*/

export const BURST = {
  viewBox: '0 0 1268 1268',
  path: 'M713.904 1266.87H551.504L627.759 668.812H637.65L713.904 1266.87ZM1019.16 1141.05L878.513 1222.25L645.521 666.185L654.088 661.238L1019.16 1141.05ZM619.666 665.494L386.675 1221.56L246.031 1140.36L611.099 660.548L619.666 665.494ZM1221.34 880.273L1140.14 1020.92L660.331 655.848L665.276 647.281L1221.34 880.273ZM605.373 655.114L125.564 1020.18L44.3641 879.539L600.427 646.548L605.373 655.114ZM598.795 628.749V638.641L0.734192 714.895V552.494L598.795 628.749ZM1266.73 714.777L668.674 638.522V628.631L1266.73 552.376V714.777ZM605.72 612.375L600.774 620.941L44.7117 387.95L125.912 247.307L605.72 612.375ZM1222.16 386.786L666.096 619.778L661.15 611.212L1140.96 246.143L1222.16 386.786ZM619.584 601.087L611.017 606.032L245.949 126.225L386.593 45.0244L619.584 601.087ZM1019.07 125.967L654.006 605.774L645.439 600.828L878.431 44.7656L1019.07 125.967ZM636.872 598.933H626.98L550.725 0.87207H713.126L636.872 598.933Z',
  gradient: { cx: 634, cy: 634, r: 634 },
  /** `inner` is the bright middle, `outer` the colour the rays fade through. */
  stops: [
    { offset: 0, color: 'inner' },
    { offset: 0.4, color: 'outer' },
    { offset: 0.7, color: 'outer', opacity: 0.3 },
    { offset: 1, color: 'outer', opacity: 0 },
  ],
  /** How long the burst takes to scale up from nothing, in ms. */
  duration: 1000,
} as const;

/** Which of the two game colours a stop takes. */
export type BurstStopColor = 'inner' | 'outer';
